import {
  useCurrentRefinements,
  useRefinementList,
} from "react-instantsearch-hooks-web";
import * as Checkbox from "@radix-ui/react-checkbox";
import { BiCheck } from "react-icons/bi";

function TownFilterMobile() {
  const {
    items,
    hasExhaustiveItems,
    createURL,
    refine,
    sendEvent,
    searchForItems,
    isFromSearch,
    canRefine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({ attribute: "propertyTown.townName" });
  const props = useCurrentRefinements();
  //  console.log(props.canRefine, props.canRefine, props.createURL)
  const itemRefs = props.items;
  // console.log(itemRefs);
  const arr = itemRefs.find((c) => c.attribute === "propertyTown.townName");
  // console.log(arr)
  // {arr && arr?.refinements?.length != 0
  //   ? `Towns (${arr?.refinements.length})`
  //   : "Town"}  //count
  return (
    <>
      <div className="grid grid-cols-3">
        {items?.map((item) => {
          // console.log(item.value);
          let exists =
            arr?.refinements.find((el) => el.value === item.value)?.value ===
            item.value;
          // console.log(exists);
          return (
            <div
              key={item.value}
              className="flex flex-row  items-center space-x-2"
            >
              <Checkbox.Root
                className={
                  "flex h-6 w-6 items-center justify-center rounded-md " +
                  (exists
                    ? "  bg-zote-primary"
                    : " border border-gray-300 bg-white")
                }
                checked={exists}
                value={item.value}
                name={item.value}
                onCheckedChange={(val) => {
                  if (val) {
                    refine(item.value);
                  } else {
                    refine(item.value);
                  }
                }}
                id={item.value}
              >
                <Checkbox.Indicator className="  flex items-center justify-center">
                  <BiCheck className={"h-5 w-5 text-gray-100  "} />
                </Checkbox.Indicator>
              </Checkbox.Root>
              <label className="" htmlFor={item.value}>
                {item.label}
              </label>
            </div>
          );
        })}
      </div>
    </>
  );
}
export default TownFilterMobile;
